import React from 'react'

function FeedbackSuccessPage() {
  return (
    <div>FeedbackSuccessPage</div>
  )
}

export default FeedbackSuccessPage